<template>
    <div>
        <h3 class="text-lg leading-6 font-medium text-secondaryColor mb-4">
            {{ value.label }}
        </h3>
        <div
            v-if="isConnected || (isIdentified && value.reponse_private == 0)"
            class="sm:col-span-2"
        >
            <dd
                v-for="(file, index) in value.value"
                :key="index"
                class="mt-1 text-sm text-gray-900"
            >
                <figure
                    v-if="
                        ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].includes(
                            getMedia(file).name.split('.').pop()
                        )
                    "
                    class="mt-5 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-blue-500 group block w-full aspect-w-10 aspect-h-7 rounded-lg overflow-hidden"
                >
                    <img :src="`${baseURL}/storage/${file}/citizen`" />
                </figure>
                <div
                    v-else-if="
                        !['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].includes(
                            getMedia(file).name.split('.').pop()
                        )
                    "
                >
                    <a
                        :href="`${baseURL}/storage/${file}/citizen`"
                        target="_blank"
                        >{{ getMedia(file).name }}</a
                    >
                </div>
            </dd>
        </div>
        <div v-else-if="isIdentified && value.reponse_private == 1">
            <div>{{ $t('post.page.file_connected') }}</div>
            <p>{{ getMedia(file).name }}</p>
        </div>
        <div v-else>
            {{ $t('post.page.file_not_connected') }}
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'FileUploadAttribute',
    props: ['value', 'medias', 'isIdentified'],
    created() {
        this.token = window.localStorage.getItem('token')
        this.firebase = window.localStorage.getItem('firebase')
        this.baseURL = axios.defaults.baseURL
    },
    data() {
        return {
            firebase: '',
            token: '',
            baseURL: ''
        }
    },
    methods: {
        getMedia(id) {
            return this.medias.filter((media) => media.id == id)[0]
        },
        isConnected() {
            if (this.token != '' && this.token != null) return true
            return false
        }
    }
}
</script>

<style scoped></style>
